import React from "react";
import PropTypes from "prop-types";
import { isEmpty } from "lodash";
import { getVarsoUrl } from "../../../../../common/helpers/helpers";

const AdditionalLinksResources = ({ selectedGene }) => {
  if (isEmpty(selectedGene)) return null;
  const decipherUrl = `https://www.deciphergenomics.org/gene/${selectedGene.symbol}/overview/clinical-info`;
  const cosmicUrl = `http://cancer.sanger.ac.uk/cosmic/gene/overview?ln=${selectedGene.symbol}`;
  const nihUrl = `https://ghr.nlm.nih.gov/gene/${selectedGene.symbol}`;
  const omimUrl = `https://www.ncbi.nlm.nih.gov/omim/?term=${selectedGene.symbol}`;
  const malacardsUrl = `https://www.malacards.org/search/results?q=+[GE]+${selectedGene.symbol}`;
  return (
    <div className="varsome-horiz-list-item">
      <div className="varsome-horiz-list-label">Clinical resources</div>
      <div className="varsome-horiz-list-value">
        <a
          href={getVarsoUrl(decipherUrl)}
          target="_blank"
          className="varsome-gene-link"
        >
          DECIPHER
        </a>

        <a
          href={getVarsoUrl(cosmicUrl)}
          target="_blank"
          className="varsome-gene-link"
        >
          COSMIC
        </a>

        <a
          href={getVarsoUrl(nihUrl)}
          target="_blank"
          className="varsome-gene-link"
        >
          NIH Genetics Home Reference
        </a>
        <a
          href={getVarsoUrl(omimUrl)}
          target="_blank"
          className="varsome-gene-link"
        >
          OMIM
        </a>
        <a
          href={getVarsoUrl(malacardsUrl)}
          target="_blank"
          className="varsome-gene-link"
        >
          MalaCards
        </a>
      </div>
    </div>
  );
};

AdditionalLinksResources.propTypes = {
  selectedGene: PropTypes.shape({
    symbol: PropTypes.string,
  }),
};

AdditionalLinksResources.defaultProps = {
  selectedGene: null,
};

export default AdditionalLinksResources;
